import { useEffect, useRef, useState } from 'react'

import { IDocument } from '../../../interfaces'
import { FetchDocumentContent } from './document-upload-context-types'

type DocumentContentObjectUrlResult = {
  objectUrl: string | undefined
  hasError: boolean
}

const useDocumentContentObjectUrl = (
  document: IDocument | undefined,
  fetchDocumentContent: FetchDocumentContent,
): DocumentContentObjectUrlResult => {
  const [objectUrl, setObjectUrl] = useState<string | undefined>(undefined)
  const [hasError, setHasError] = useState<boolean>(false)

  const documentRef = useRef(document)
  documentRef.current = document

  useEffect(() => {
    setObjectUrl(undefined)
    setHasError(false)

    const currentDocument = documentRef.current

    if (!currentDocument?.contentUrl) {
      setHasError(true)
      return undefined
    }

    let isCancelled = false
    let createdObjectUrl: string | undefined

    fetchDocumentContent(currentDocument)
      .then(blob => {
        if (isCancelled) {
          return
        }

        createdObjectUrl = window.URL.createObjectURL(blob)
        setObjectUrl(createdObjectUrl)
      })
      .catch(err => {
        if (isCancelled) {
          return
        }

        console.warn('Failed to load document preview', err)
        setHasError(true)
      })

    return () => {
      isCancelled = true

      if (createdObjectUrl) {
        window.URL.revokeObjectURL(createdObjectUrl)
      }
    }
  }, [document?.id, document?.contentUrl, fetchDocumentContent])

  return { objectUrl, hasError }
}

export default useDocumentContentObjectUrl
